import { AnimationOnScroll } from "react-animation-on-scroll";

export default function SectionHeader({ children }) {
  return (
    <h2 className="text-5xl font-bold self-start sm:ml-16 hidden sm:block mb-8">
      <AnimationOnScroll animateIn={"animate__fadeInLeft"}>
        {children}
      </AnimationOnScroll>
    </h2>
  );
}
